import { pipe } from 'fp-ts/lib/function'
import * as t from 'io-ts'
import {mapFrom} from '../fp-ts-util'
import { S } from '../fp-ts-imp'
import { WithId } from './vd-api/id'

export const OrganizationC = t.strict(
  {
    name: t.string,
    maxUserCount: t.string,
  },
  'Organizations',
)

export type Organization = WithId<t.TypeOf<typeof OrganizationC>>

export const vROrgId = '000000000000000000000000'

export const vROrg: Organization = {
  id: vROrgId,
  name: 'Vertical Raise',
  maxUserCount: '0',
}

export const mapFromOrgs = (os: ReadonlyArray<Organization>): Map<string, Organization> =>
  pipe(
    os,
    mapFrom(S.Eq, ({id}) => id)
  )
